export const TOKENS_AUTHENTICATION = {
  investigated: 'token',
  pm: 'token',
  user_and_prosecutor: 'token',
};
